import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const getInquiries = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/inquiry'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getInquiryById = async ({
	params = { inquiryId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}`
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const deleteInquiry = async ({
	params = { inquiryId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateInquiryStatus = async ({
	params = { inquiryId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}/status`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateInquiryHandler = async ({
	params = { inquiryId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}/handler`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const addInquiryComment = async ({
	params = { inquiryId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}/comment`
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getInquiryComments = async ({
	params = { inquiryId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}/comment`
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const deleteInquiryComment = async ({
	params = { inquiryId: '', commentId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}/comment/${params.commentId}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getInquiryStatusLog = async ({
	params = { inquiryId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}/status-log`
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 이메일 답변 — multipart: subject · html · files(첨부, 최대 5 · 합계 7MB) */
export const sendInquiryReply = async ({
	params = { inquiryId: '' },
	body = { subject: '', html: '' },
	files = [],
	customHeaders = {},
}: {
	params?: { inquiryId: string }
	body?: { subject: string; html: string }
	files?: File[]
	customHeaders?: { [key: string]: any }
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}/reply`
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: Api.createFormData(body, files),
			query: {},
			customHeaders: { ...customHeaders, 'Content-Type': 'multipart/form-data' },
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 답변 본문 이미지 한 장 → 공개 URL */
export const uploadInquiryReplyImage = async ({
	params = { inquiryId: '' },
	file,
	customHeaders = {},
}: {
	params?: { inquiryId: string }
	file: File
	customHeaders?: { [key: string]: any }
}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}/reply-image`
		const formData = new FormData()
		formData.append('file', file)
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: formData,
			query: {},
			customHeaders: { ...customHeaders, 'Content-Type': 'multipart/form-data' },
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 이메일 답변 첨부 받기 → [{ fileName, contentType, base64 }] */
export const getInquiryReplyFile = async ({
	params = { inquiryId: '', fileId: '' },
	customHeaders = {},
}: {
	params?: { inquiryId: string; fileId: string }
	customHeaders?: { [key: string]: any }
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}/file/${params.fileId}`
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: {},
			query: {},
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const inquiryMgmtApi = {
	getInquiryReplyFile,
	sendInquiryReply,
	uploadInquiryReplyImage,
	getInquiries,
	getInquiryById,
	deleteInquiry,
	updateInquiryStatus,
	updateInquiryHandler,
	addInquiryComment,
	getInquiryComments,
	deleteInquiryComment,
	getInquiryStatusLog,
}

export default inquiryMgmtApi
